import { Helmet } from 'react-helmet';
import KhrDetail
  from 'src/components/khr-detail/KhrDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import KhrListToolbar from '../components/khr-detail/KhrToolbar';

const Khr = () => (
  <>
    <Helmet>
      <title>Khách hàng riêng</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <KhrListToolbar />
        <Box sx={{ pt: 3 }}>
          <KhrDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Khr;
